/**
 * Created by Edgars on 25/10/2016.
 */
import * as types from '../mutation-types'

// initial state
const state = {
    isVisible: false,
    activeGroup: null,
    isEditing: false,
		isParentClass: false
}

// mutations
const mutations = {

    [types.GROUP_FORM_MODAL_ADD_NEW] (state) {
        state.isVisible = true;
        state.isEditing = false;
    },
		
    [types.GROUP_FORM_MODAL_EDIT] (state, { group }) {
        state.isVisible = true;
        state.activeGroup = group;
        state.isEditing = true;
    },


    [types.GROUP_FORM_MODAL_CLOSE] (state) {
        state.isVisible = false;
        state.activeGroup = {};
    },
		
		// #3422 QuickFix - Allow to create parent classes in the parent respondent view.
		// This will be removed soon.
		[types.GROUP_FORM_MODAL_SWITCH_TO_PARENT_CLASS] (state, { booleanValue }) {
        state.isParentClass = booleanValue;
    },
}

const getters = {
}

export default {
    state,
    mutations,
    getters,
}